// LIVE-RECORDING-ASPECT-RATIO-9X16-1 · 실제 영상 픽셀로 세로/가로 판정.
export const isPortraitVideo = (w, h) => Number(h) > Number(w) && Number(w) > 0;
